<span class="text-danger">{{label()}} is already taken.</span>